const Repository = require('../base')
const { prepareTranslit } = require('../../helpers')

module.exports = class CoursesRepository extends Repository {
    constructor() {
        super({
            source: 'elastic',
            path: 'courses'
        })
    }

    search(value = '') {
        const translit = prepareTranslit(value)
        const searchLanguages = [
            'English',
            'German',
            'Spanish',
            'French',
            'Italian',
            'Korean'
        ]

        this.highlight = {
            pre_tags: ['<mark>'],
            post_tags: ['</mark>'],
            fields: {
                title: {}
            }
        }

        this.where((q) => {
            const hasLanguage = searchLanguages.filter((el) =>
                value.includes(el.toLowerCase())
            )

            q.where('translit', {
                query: translit,
                prefix_length: 3,
                fuzziness: 'auto',
                boost: 0.1
            })

            if (hasLanguage.length) {
                q.orWhere('language.Name', {
                    query: hasLanguage[0],
                    boost: 0.8
                })
            }

            q.orWhere('location.city', {
                query: value,
                prefix_length: 3,
                boost: 8
            })

            q.orWhere('location.street', {
                query: value,
                prefix_length: 3,
                boost: 10
            })

            q.orWhere('title', {
                query: value,
                prefix_length: 3,
                fuzziness: 'auto',
                boost: 15
            })

            for (const language of ['en', 'ru', 'de', 'hy']) {
                q.orWhere(`title_${language}`, {
                    query: value,
                    prefix_length: 3,
                    fuzziness: 'auto',
                    boost: 15
                })

                // q.orWhere(`description_${language}`, {
                //   query: value,
                //   prefix_length: 3,
                //   fuzziness: "auto",
                //   boost: 0.1
                // });

                q.orWhere(`language.Name_${language}`, {
                    query: value,
                    prefix_length: 3,
                    fuzziness: 'auto',
                    boost: 0.4
                })

                q.orWhere(`level.Name_${language}`, {
                    query: value,
                    prefix_length: 3,
                    fuzziness: 'auto',
                    boost: 0.4
                })

                q.orWhere(`coursetypes.title_${language}`, {
                    query: value,
                    prefix_length: 3,
                    fuzziness: 'auto',
                    boost: 0.4
                })
            }

            q.orWhere('level.searchLevel', {
                query: value,
                boost: 0.4
            })

            q.orWhere('school.title', {
                query: value,
                prefix_length: 3,
                fuzziness: 'auto',
                boost: 10
            })

            const searchTerm = value
                .replace(' ', '')
                .replace('_', '')
                .toLowerCase()

            if (searchTerm.includes('group')) {
                q.orWhere('Group', {
                    query: true,
                    boost: 0.7
                })
            }

            if (searchTerm.includes('individual')) {
                q.orWhere('Group', {
                    query: false,
                    boost: 0.7
                })
            }

            if (searchTerm.includes('freetrial')) {
                q.orWhere('free_trial', {
                    query: true,
                    boost: 0.7
                })
            }
        })

        return this
    }
}
